import React, { Component } from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";
import "./AboutUsPage.css";
import "../../index.css";
import Objective from "../../components/Objective/Objective.js";
import IconNumber from "../../../src/components/IconNumber/IconNumber";
import FundingFact from "../../components/FundingFact/FundingFact";
import MemberCard from "../../components/MemberCard/MemberCard";

class AboutUsPage extends Component {
  constructor() {
    super();

    this.state = { classlist: "AboutUsPage" };
  }

  render() {
    return (
      <div className="container">
        <h1 className="about-title">We are SWB</h1>

        <div class="about-swb">
          <div
            className="about-img"
            style={{ backgroundImage: "var(--about-swb)" }}
          ></div>
          <p className="about-swb-p">
            <div className="section-p">
              Statistics Without Borders (SWB) is a volunteer Outreach Group of
              the American Statistical Association (ASA) that provides pro bono
              services in statistics and data science. We work to improve
              decision making and knowledge in efforts that promote welfare
              through the proper application of statistical principles and best
              practices, where access to such resources is limited.
            </div>
            <div className="section-p">
              SWB was established in 2008 and provides a focus for pro bono
              statistical consulting within the American statistical
              Association. SWB provides an opportunity for statisticians to
              collaborate with professionals, researchers, and other volunteers
              involved in international health work.
            </div>
            <div className="section-p">
              SWB arose fromt the excitment generated by a topic-contributed
              panel entitled "Statisticians: Speaking Out and Reaching Out on
              Global Health" at the 2008 Joint Statistical Meetings in Denver,
              Colorado. Steve Pierson, Gary Shapiro, Jim Cochran, and Fritz
              Scheuren established Statistics Without Borders as an effort
              within the ASA's Special Interest Group (SIG) on Volunteerism.
              Established in 2005, the SIG on Volunteerism provided pro bono
              statistical consulting internationally, with a focus on human
              rights issues.
            </div>
          </p>
        </div>
        <div className="aboutus-section">
          <h1 className="about-title">How We Started</h1>
          <div className="objective-section objective-section-one">
            <Objective
              year="2008"
              text="It was the excitement around topic-contributed
                      panel at the 2008 Joint Statistical Meetings in Denver, Colorado that sparked the
                      conversation between Gary Shapiro and Fritz Scheuren, which eventually resulted in the
                      formation of Statistics Without Borders (SWB) the same year."
            />
          </div>
          <div className="objective-section">
            <Objective
              year="2010"
              text="In 2010, SWB became an outreach organization of the ASA, and it drafted its first mission and
                      vision having just 130 people on board that year."
            />
          </div>
          <div className="objective-section">
            <Objective
              year="2014"
              text='At the 2014 JSM SWB Business Meeting, two new amendments were introduced to the Charter 
                      by Gary Shapiro. One of the amendments was to extend the definition of a project from global health
                      to include "...the use of statistics to improve the health and well-being of all people."'
            />
          </div>
          <div className="objective-section">
            <Objective
              year="2020"
              text="As of today, more than 1400 volunteers have joined SWB's team!"
            />
          </div>
        </div>
        <div className="aboutus-section">
          <h1 className="member-header">Our Members</h1>
          <div className="member-parent-container">
            {/* <div className="member-row"> */}
              <div className="member-cards">
                <MemberCard
                  image="var(--about-jean)"
                  name="Jean Opsomer"
                  position="Chair"
                  about="Jean Opsomer is Professor and Chair in the Department of Statistics at Colorado State University. His main areas of statistical expertise are survey statistics and nonparametric methods. He is delighted to be able to assist SWB as it continues to expand its operations and develops a more effective organizational structure."
                />
              </div>
              <div className="member-cards">
                <MemberCard
                  image="var( --about-jae)"
                  name="Jae Brodsky"
                  position="Vice Chair"
                  about="Jae Brodsky works in statistical genetics on problems in machine learning, big data analysis, and Bayesian techniques. She has a Ph.D. in statistics from UCLA and previously worked at the FDA."
                />
              </div>
              <div className="member-cards">
                <MemberCard
                  image="var(--about-davina)"
                  name="Davina Durgana"
                  position="Vice-Chair Elect"
                  about="Davina P. Durgana, PhD is an award-winning international human rights statistician who has developed leading global models to assess risk and vulnerability to modern slavery. Dr. Durgana is a Report Co-Author and Senior Statistician on the Global Slavery Index of the Minderoo Foundation’s Walk Free Initiative...   Voluptate magna dolor ex aliquip. Magna fugiat mollit ad consectetur cupidatat ea enim esse ut quis laboris cillum. Laboris minim eu ex mollit culpa eu do tempor fugiat quis eu. Magna dolore eiusmod proident reprehenderit laborum laboris qui fugiat ea elit. Fugiat qui incididunt fugiat Lorem."
                  IconDownArrow
                />
              </div>
            {/* </div> */}
            {/* <div className="member-row"> */}
              <div className="member-cards">
                <MemberCard
                  image="var(--about-david)"
                  name="David Whitford"
                  position="Engagement Director"
                  about="David Whitford was formerly with the U.S Census Bureau and led the division of statisticians responsible for statistical aspects of the Decennial Censuses and the monthly American Community Survey. He currently provides consultation on survey methodology to developing countries, governments, and NGOs. His interests are dual system estimation, record linkage, R, tennis, and travel."
                />
              </div>
              <div className="member-cards">
                <MemberCard
                  image="var(--about-smita)"
                  name="Smita Skrivanek"
                  position="Operations Director"
                  about="
                Smita Skrivanek works in the field of quality and continuous improvement and consults on process improvement projects. She is interested in human rights, animal rights, environmental and social justice issues."
                />
              </div>
              <div className="member-cards">
                <MemberCard
                  image="var(--about-matt)"
                  name="Matt Brems"
                  position="Marketing & Communications Director"
                  about="Matt Brems works at General Assembly as a data science instructor and is managing partner of a consultancy, BetaVector. He is interested in data visualization, missing data, and Python programming. He holds a Master's degree in statistics from The Ohio State University."
                />
              </div>
            {/* </div> */}
            {/* <div className="member-row"> */}
              <div className="member-cards">
                <MemberCard
                  image="var(--about-cathy)"
                  name="Cathy Furlong"
                  position="Past Chair (emeritus)"
                  about="Client acquisition co-chair. Cathy Furlong is currently employed in the Medicare fraud industry where she works on data mining, sampling/extrapolations, and Administrative Law Hearings with Medicare data. She holds a Masters in Statistics from American University. Her areas of interest are human rights and nature. Other areas of volunteer work are as a Fair Fax County Master Gardener, on the Glen Echo Park Waltz Committee, and with the Caucus for Women in Statistics."
                />
              </div>
              <div className="member-cards">
                <MemberCard
                  image="var(--about-gary)"
                  name="Gary Shapiro"
                  position="Co-Founder"
                  about="Currently the new client acquisition co-chair. Gary Shapiro is retired from Westat, where he was Senior Statistician from 1996 to 2009. Gary was the lead statistician, senior statistician, or/and task leader on over 30 projects, mostly involving survey sample design, weighting, and variance estimation. Prior to being at Westat, Gary was a Senior Statistician at Abt Associates from 1993 to 1996, where he was the lead statistician for a number of surveys. From 1965 to 1993 Gary was at the US...Voluptate magna dolor ex aliquip. Magna fugiat mollit ad consectetur cupidatat ea enim esse ut quis laboris cillum. Laboris minim eu ex mollit culpa eu do tempor fugiat quis eu. Magna dolore eiusmod proident reprehenderit laborum laboris qui fugiat ea elit. Fugiat qui incididunt fugiat Lorem.The End"
                  IconDownArrow
                />
              </div>
              <div className="member-cards">
                <MemberCard
                  image="var(--about-steve)"
                  name="Steve Pierson"
                  position="Co-Founder"
                  about="And also an ASA ex officio board member. Steve has been ASA Director of Science Policy since March, 2008. Previously, he was Head of Government Relations for the American Physical Society and Associate Professor of Physics at Worcester Polytechnic Institute in Worcester, MA."
                />
              </div>
            {/* </div> */}
          </div>
        </div>
        <div className="aboutus-section">
          <h1 className="number-icons-header">Objectives</h1>
          <div className="number-icons-section">
            <div className="number-icons-objectives">
              <div className="number-icons-icon">
                <IconNumber type="digit" IconNumber box label="01" />
              </div>
              <p className="number-icons-text">
                SWB advocates objective, impartial, and sound decision making
                using best statistical practices.
              </p>
            </div>
            <div className="number-icons-objectives">
              <div className="number-icons-icon">
                <IconNumber type="digit" IconNumber two label="02" />
              </div>
              <p className="number-icons-text">
                SWB provides analytical services through client projects for
                public benefit that support goals that are non-religious,
                non-political, and non-personal, with a focus on developing
                countries.
              </p>
            </div>
            <div className="number-icons-objectives">
              <div className="number-icons-icon">
                <IconNumber type="digit" IconNumber three label="03" />
              </div>
              <p className="number-icons-text">
                SWB assists organizations outside of the for-profit sector, with
                priorities given to organizations with limited access to
                statistical resources.
              </p>
            </div>
            <div className="number-icons-objectives">
              <div className="number-icons-icon">
                <IconNumber type="digit" IconNumber four label="04" />
              </div>
              <p className="number-icons-text">
                SWB strengthens its clients and their communities by helping them
                build their capacities in statistics, data science and analytics,
                and promotes best practices in these areas.
              </p>
            </div>
          </div>
          <p className="charter-text">
            Read the{" "}
            <a
              href="https://swb.wildapricot.org/resources/Documents/SWB%20Charter%20v202.pdf"
              className="charter-underline"
            >
              SWB Charter
            </a>
          </p>
        </div>
        <div className="aboutus-section">
          <div className="funding-facts-section">
            <h1 className="funding-facts-header">Funding Facts</h1>
            <div className="funding-facts-fact">
              <FundingFact
                image="var(--about-give-heart)"
                description="SWB does not accept payments or remunerations of any kind."
                imgPositionRight
              />
            </div>
            <div className="funding-facts-fact">
              {" "}
              <FundingFact
                image="var(--about-receive-heart)"
                description="If you would like to donate, the ASA will accept donations earmarked for SWB use."
              />{" "}
            </div>
            <div className="funding-facts-fact">
              {" "}
              <FundingFact
                image="var(--about-no-fees)"
                description="SWB does not collect any volunteer fees or subscription dues."
                imgPositionRight
              />
            </div>
            <div className="funding-facts-fact">
              {" "}
              <FundingFact
                image="var(--about-donate)"
                description="All donations are used 100% for SWB projects and are never used for payments or reimbursements."
              />
            </div>
          </div>
          <p className="funding-facts-readtext">
            {" "}
            Read the&nbsp;
            <a
              href="https://swb.wildapricot.org/resources/Documents/POLICY%20-%20Code%20of%20Conduct%20for%20SWB%20Volunteers.pdf"
              className="volunteer-underline"
            >
              Volunteer Code of Conduct
            </a>
            &nbsp;and&nbsp;
            <a
              href="https://swb.wildapricot.org/resources/Documents/Policy%20-%20Privacy%20Statement%20v002.pdf"
              className="privacy-policy-underline"
            >
              Privacy Policy
            </a>
          </p>
        </div>
        <div className="aboutus-section aboutus-bottom-section">

        <h1 className="broadgreen-header">SWB and ASA: Broadgreen Solutions</h1>
        <div className="broadgreen-section">
          <p>
            In 2017, the American Statistical Association and SWB explored how
            to move SWB from an outreach group to a more established entity
            within ASA that continues to reflect its unique characteristics. It
            also explicitly recognized that SWB is accountable to the ASA Board
            and that SWB volunteers are expected to adhere to the ASA Ethical
            Guidelines for Statistical Practice. This gives SWB financial
            support from ASA and the ability for SWB to manage limited funds in
            a manner similar to that of the ASA chapters and sections.{" "}
          </p>
          <p>
            SWB is grateful for the assistance and leadership provided by
            Broadgreen Solutions. Broadgreen Solutions, a Certified B Corp that
            provides transformation and advisory services, performed exhaustive
            interviews with SWB Executive Committee members, ASA leadership, SWB
            organizational partners and other non-profit volunteer associations
            to discuss the pros and cons of organizational structure, and
            provided SWB with recommmendations on our future roadmap. SWB also
            thanks ASA Associate Executive Director Steve Porzio for his
            invaluable guidance.
          </p>
          <p>
            SWB has grown substantially over the past decade. This rapid growth
            has enabled SWB to take on more projects, but it has also required
            the Executive Committe to rethink both of its organizational
            structure, policies, and procedures. Ultimately, the goal of the SWB
            Executive Committee is to improve the ability of SWB to be an
            effective organization promoting the greater good through
            statistical practice, and do so as an integral part of the ASA
            organization. SWB looks forward to these positive changes.
          </p>
        </div>
        </div>
      </div>
    );
  }
}

export default AboutUsPage;
